import "./style.css";
import { getInstance } from "@app";
import layout from "./layout.html";

export default class BazarIntro {
  static selector = ".bazar__intro";

  constructor(block) {
    this.block = block;
    this.block.innerHTML = layout;
  }

  onReady = () => {};

  onComplete = () => {};

  onResize = () => {};
}
